export default __webpack_public_path__ + "static/media/yellowback.62392492.png";